/** Display helpers for business/user country values stored in the DB. */

const KNOWN_COUNTRY_LABELS: Record<string, string> = {
  USA: 'United States',
  US: 'United States',
  Canada: 'Canada',
  CA: 'Canada',
  'New Zealand': 'New Zealand',
  NZ: 'New Zealand',
};

/** Common free-text / alias → ISO 3166-1 alpha-2 (lowercase) for flagcdn. */
const COUNTRY_NAME_TO_ISO: Record<string, string> = {
  usa: 'us',
  us: 'us',
  'united states': 'us',
  'united states of america': 'us',
  america: 'us',
  canada: 'ca',
  ca: 'ca',
  india: 'in',
  in: 'in',
  philippines: 'ph',
  ph: 'ph',
  'new zealand': 'nz',
  nz: 'nz',
  australia: 'au',
  au: 'au',
  'united kingdom': 'gb',
  uk: 'gb',
  gb: 'gb',
  mexico: 'mx',
  mx: 'mx',
  ireland: 'ie',
  ie: 'ie',
  singapore: 'sg',
  sg: 'sg',
  uae: 'ae',
  'united arab emirates': 'ae',
  ae: 'ae',
  germany: 'de',
  de: 'de',
  france: 'fr',
  fr: 'fr',
  japan: 'jp',
  jp: 'jp',
  china: 'cn',
  cn: 'cn',
  brazil: 'br',
  br: 'br',
  'south africa': 'za',
  za: 'za',
  pakistan: 'pk',
  pk: 'pk',
  bangladesh: 'bd',
  bd: 'bd',
  nepal: 'np',
  np: 'np',
  'sri lanka': 'lk',
  lk: 'lk',
};

export function labelForStoredCountry(value: string | null | undefined): string {
  const raw = (value || '').trim();
  if (!raw) return '';
  return KNOWN_COUNTRY_LABELS[raw] || raw;
}

/** Resolve stored country to lowercase ISO code for flag images, or null if unknown. */
export function storedCountryToIsoCode(value: string | null | undefined): string | null {
  const raw = (value || '').trim();
  if (!raw) return null;

  const key = raw.toLowerCase();
  if (COUNTRY_NAME_TO_ISO[key]) return COUNTRY_NAME_TO_ISO[key];

  // Already an ISO alpha-2 code
  if (/^[a-z]{2}$/i.test(raw)) return raw.toLowerCase();

  return null;
}
